import {CountriesList, LiveCountryList, PrefixesList, StatesList} from "../interfaces/prefixes-list";

export const countryOptions: CountriesList = {
  emea: [
    {value: 'be', label: 'Belgium'},
    {value: 'bg', label: 'Bulgaria'},
    {value: 'ba', label: 'Bosnia and Herzegovina'},
    {value: 'je', label: 'Jersey'},
    {value: 'by', label: 'Belarus'},
    {value: 'ru', label: 'Russia'},
    {value: 'rs', label: 'Serbia'},
    {value: 'ro', label: 'Romania'},
    {value: 'gr', label: 'Greece'},
    {value: 'gg', label: 'Guernsey'},
    {value: 'gb', label: 'United Kingdom'},
    {value: 'gi', label: 'Gibraltar'},
    {value: 'hr', label: 'Croatia'},
    {value: 'hu', label: 'Hungary'},
    {value: 'pt', label: 'Portugal'},
    {value: 'sj', label: 'Svalbard and Jan Mayen'},
    {value: 'pl', label: 'Poland'},
    {value: 'ee', label: 'Estonia'},
    {value: 'it', label: 'Italy'},
    {value: 'es', label: 'Spain'},
    {value: 'me', label: 'Montenegro'},
    {value: 'md', label: 'Moldova'},
    {value: 'mc', label: 'Monaco'},
    {value: 'mk', label: 'Macedonia'},
    {value: 'mt', label: 'Malta'},
    {value: 'im', label: 'Isle of Man'},
    {value: 'fr', label: 'France'},
    {value: 'fi', label: 'Finland'},
    {value: 'fo', label: 'Faroe Islands'},
    {value: 'nl', label: 'Netherlands'},
    {value: 'no', label: 'Norway'},
    {value: 'xk', label: 'Kosovo'},
    {value: 'ch', label: 'Switzerland'},
    {value: 'cz', label: 'Czech Republic'},
    {value: 'cy', label: 'Cyprus'},
    {value: 'sk', label: 'Slovakia'},
    {value: 'si', label: 'Slovenia'},
    {value: 'sm', label: 'San Marino'},
    {value: 'se', label: 'Sweden'},
    {value: 'dk', label: 'Denmark'},
    {value: 'de', label: 'Germany'},
    {value: 'li', label: 'Liechtenstein'},
    {value: 'lv', label: 'Latvia'},
    {value: 'lt', label: 'Lithuania'},
    {value: 'lu', label: 'Luxembourg'},
    {value: 'va', label: 'Vatican'},
    {value: 'ad', label: 'Andorra'},
    {value: 'is', label: 'Iceland'},
    {value: 'al', label: 'Albania'},
    {value: 'at', label: 'Austria'},
    {value: 'ax', label: 'Aland Islands'},
    {value: 'ie', label: 'Ireland'},
    {value: 'ua', label: 'Ukraine'},
  ],
  nafta: [
    {value: 'bb', label: 'Barbados'},
    {value: 'bl', label: 'Saint Barthelemy'},
    {value: 'bm', label: 'Bermuda'},
    {value: 'jm', label: 'Jamaica'},
    {value: 'bq', label: 'Bonaire, Saint Eustatius and Saba '},
    {value: 'bs', label: 'Bahamas'},
    {value: 'bz', label: 'Belize'},
    {value: 'gt', label: 'Guatemala'},
    {value: 'gp', label: 'Guadeloupe'},
    {value: 'gd', label: 'Grenada'},
    {value: 'sv', label: 'El Salvador'},
    {value: 'gl', label: 'Greenland'},
    {value: 'ht', label: 'Haiti'},
    {value: 'hn', label: 'Honduras'},
    {value: 'pr', label: 'Puerto Rico'},
    {value: 'pa', label: 'Panama'},
    {value: 'pm', label: 'Saint Pierre and Miquelon'},
    {value: 'mf', label: 'Saint Martin'},
    {value: 'mq', label: 'Martinique'},
    {value: 'ms', label: 'Montserrat'},
    {value: 'mx', label: 'Mexico'},
    {value: 'ni', label: 'Nicaragua'},
    {value: 'ca', label: 'Canada'},
    {value: 'cr', label: 'Costa Rica'},
    {value: 'cw', label: 'Curacao'},
    {value: 'cu', label: 'Cuba'},
    {value: 'sx', label: 'Sint Maarten'},
    {value: 'kn', label: 'Saint Kitts and Nevis'},
    {value: 'ky', label: 'Cayman Islands'},
    {value: 'do', label: 'Dominican Republic'},
    {value: 'dm', label: 'Dominica'},
    {value: 'vg', label: 'British Virgin Islands'},
    {value: 'us', label: 'United States'},
    {value: 'lc', label: 'Saint Lucia'},
    {value: 'tt', label: 'Trinidad and Tobago'},
    {value: 'tc', label: 'Turks and Caicos Islands'},
    {value: 'vc', label: 'Saint Vincent and the Grenadines'},
    {value: 'ag', label: 'Antigua and Barbuda'},
    {value: 'ai', label: 'Anguilla'},
    {value: 'vi', label: 'U.S. Virgin Islands'},
    {value: 'aw', label: 'Aruba'},
  ],
  latam: [
    {value: 'bo', label: 'Bolivia'},
    {value: 'br', label: 'Brazil'},
    {value: 'gy', label: 'Guyana'},
    {value: 'gf', label: 'French Guiana'},
    {value: 've', label: 'Venezuela'},
    {value: 'py', label: 'Paraguay'},
    {value: 'pe', label: 'Peru'},
    {value: 'ec', label: 'Ecuador'},
    {value: 'fk', label: 'Falkland Islands'},
    {value: 'co', label: 'Colombia'},
    {value: 'cl', label: 'Chile'},
    {value: 'sr', label: 'Suriname'},
    {value: 'uy', label: 'Uruguay'},
    {value: 'ar', label: 'Argentina'},
  ],
  apac: [
    //apac (iap)
    {value: 'au', label: 'Australia'},
    {value: 'in', label: 'India'},
    {value: 'kr', label: 'Korea'},
    {value: 'jp', label: 'Japan'},
  ]
}

export const statesOptions: StatesList = {
  ca: [
    {code: 'AB', value: 'Alberta', label: 'Alberta'},
    {code: 'BC', value: 'British Columbia', label: 'British Columbia'},
    {code: 'MB', value: 'Manitoba', label: 'Manitoba'},
    {code: 'NB', value: 'New Brunswick', label: 'New Brunswick'},
    {
      code: 'NL',
      value: 'Newfoundland and Labrador',
      label: 'Newfoundland and Labrador',
    },
    {
      code: 'NT',
      value: 'Northwest Territories',
      label: 'Northwest Territories',
    },
    {code: 'NS', value: 'Nova Scotia', label: 'Nova Scotia'},
    {code: 'NU', value: 'Nunavut', label: 'Nunavut'},
    {code: 'ON', value: 'Ontario', label: 'Ontario'},
    {
      code: 'PE',
      value: 'Prince Edward Island',
      label: 'Prince Edward Island',
    },
    {code: 'QC', value: 'Quebec', label: 'Quebec'},
    {code: 'SK', value: 'Saskatchewan', label: 'Saskatchewan'},
    {code: 'YT', value: 'Yukon Territory', label: 'Yukon Territory'},
  ],
  us: [
    {code: 'AL', value: 'Alabama', label: 'Alabama'},
    {code: 'AK', value: 'Alaska', label: 'Alaska'},
    {code: 'AS', value: 'American Samoa', label: 'American Samoa'},
    {code: 'AZ', value: 'Arizona', label: 'Arizona'},
    {code: 'AR', value: 'Arkansas', label: 'Arkansas'},
    {code: 'CA', value: 'California', label: 'California'},
    {code: 'CO', value: 'Colorado', label: 'Colorado'},
    {code: 'CT', value: 'Connecticut', label: 'Connecticut'},
    {code: 'DE', value: 'Delaware', label: 'Delaware'},
    {
      code: 'DC',
      value: 'District Of Columbia',
      label: 'District Of Columbia',
    },
    {
      code: 'FM',
      value: 'Federated States Of Micronesia',
      label: 'Federated States Of Micronesia',
    },
    {code: 'FL', value: 'Florida', label: 'Florida'},
    {code: 'GA', value: 'Georgia', label: 'Georgia'},
    {code: 'GU', value: 'Guam', label: 'Guam'},
    {code: 'HI', value: 'Hawaii', label: 'Hawaii'},
    {code: 'ID', value: 'Idaho', label: 'Idaho'},
    {code: 'IL', value: 'Illinois', label: 'Illinois'},
    {code: 'IN', value: 'Indiana', label: 'Indiana'},
    {code: 'IA', value: 'Iowa', label: 'Iowa'},
    {code: 'KS', value: 'Kansas', label: 'Kansas'},
    {code: 'KY', value: 'Kentucky', label: 'Kentucky'},
    {code: 'LA', value: 'Louisiana', label: 'Louisiana'},
    {code: 'ME', value: 'Maine', label: 'Maine'},
    {code: 'MH', value: 'Marshall Islands', label: 'Marshall Islands'},
    {code: 'MD', value: 'Maryland', label: 'Maryland'},
    {code: 'MA', value: 'Massachusetts', label: 'Massachusetts'},
    {code: 'MI', value: 'Michigan', label: 'Michigan'},
    {code: 'MN', value: 'Minnesota', label: 'Minnesota'},
    {code: 'MS', value: 'Mississippi', label: 'Mississippi'},
    {code: 'MO', value: 'Missouri', label: 'Missouri'},
    {code: 'MT', value: 'Montana', label: 'Montana'},
    {code: 'NE', value: 'Nebraska', label: 'Nebraska'},
    {code: 'NV', value: 'Nevada', label: 'Nevada'},
    {code: 'NH', value: 'New Hampshire', label: 'New Hampshire'},
    {code: 'NJ', value: 'New Jersey', label: 'New Jersey'},
    {code: 'NM', value: 'New Mexico', label: 'New Mexico'},
    {code: 'NY', value: 'New York', label: 'New York'},
    {code: 'NC', value: 'North Carolina', label: 'North Carolina'},
    {code: 'ND', value: 'North Dakota', label: 'North Dakota'},
    {
      code: 'MP',
      value: 'Northern Mariana Islands',
      label: 'Northern Mariana Islands',
    },
    {code: 'OH', value: 'Ohio', label: 'Ohio'},
    {code: 'OK', value: 'Oklahoma', label: 'Oklahoma'},
    {code: 'OR', value: 'Oregon', label: 'Oregon'},
    {code: 'PW', value: 'Palau', label: 'Palau'},
    {code: 'PA', value: 'Pennsylvania', label: 'Pennsylvania'},
    {code: 'PR', value: 'Puerto Rico', label: 'Puerto Rico'},
    {code: 'RI', value: 'Rhode Island', label: 'Rhode Island'},
    {code: 'SC', value: 'South Carolina', label: 'South Carolina'},
    {code: 'SD', value: 'South Dakota', label: 'South Dakota'},
    {code: 'TN', value: 'Tennessee', label: 'Tennessee'},
    {code: 'TX', value: 'Texas', label: 'Texas'},
    {code: 'UT', value: 'Utah', label: 'Utah'},
    {code: 'VT', value: 'Vermont', label: 'Vermont'},
    {code: 'VI', value: 'Virgin Islands', label: 'Virgin Islands'},
    {code: 'VA', value: 'Virginia', label: 'Virginia'},
    {code: 'WA', value: 'Washington', label: 'Washington'},
    {code: 'WV', value: 'West Virginia', label: 'West Virginia'},
    {code: 'WI', value: 'Wisconsin', label: 'Wisconsin'},
    {code: 'WY', value: 'Wyoming', label: 'Wyoming'},
  ],
  br: [
    {code: 'AC', value: 'Acre', label: 'Acre'},
    {code: 'AL', value: 'Alagoas', label: 'Alagoas'},
    {code: 'AM', value: 'Amazonas', label: 'Amazonas'},
    {code: 'AP', value: 'Amapá', label: 'Amapá'},
    {code: 'BA', value: 'Bahia', label: 'Bahia'},
    {code: 'CE', value: 'Ceará', label: 'Ceará'},
    {code: 'DF', value: 'Distrito Federal', label: 'Distrito Federal'},
    {code: 'ES', value: 'Espírito Santo', label: 'Espírito Santo'},
    {code: 'GO', value: 'Goiás', label: 'Goiás'},
    {code: 'MA', value: 'Maranhão', label: 'Maranhão'},
    {code: 'MG', value: 'Minas Gerais', label: 'Minas Gerais'},
    {
      code: 'MS',
      value: 'Mato Grosso do Sul',
      label: 'Mato Grosso do Sul',
    },
    {code: 'MT', value: 'Mato Grosso', label: 'Mato Grosso'},
    {code: 'PA', value: 'Pará', label: 'Pará'},
    {code: 'PB', value: 'Paraíba', label: 'Paraíba'},
    {code: 'PE', value: 'Pernambuco', label: 'Pernambuco'},
    {code: 'PI', value: 'Piauí', label: 'Piauí'},
    {code: 'PR', value: 'Paraná', label: 'Paraná'},
    {code: 'RJ', value: 'Rio de Janeiro', label: 'Rio de Janeiro'},
    {
      code: 'RN',
      value: 'Rio Grande do Norte',
      label: 'Rio Grande do Norte',
    },
    {code: 'RO', value: 'Rondônia', label: 'Rondônia'},
    {code: 'RR', value: 'Roraima', label: 'Roraima'},
    {code: 'RS', value: 'Rio Grande do Sul', label: 'Rio Grande do Sul'},
    {code: 'SC', value: 'Santa Catarina', label: 'Santa Catarina'},
    {code: 'SE', value: 'Sergipe', label: 'Sergipe'},
    {code: 'SP', value: 'São Paulo', label: 'São Paulo'},
    {code: 'TO', value: 'Tocantins', label: 'Tocantins'},
  ]
}

export const regionStatesOptions = {
  ca: [
    {code: 'AB', value: 'Alberta', label: 'Alberta'},
    {code: 'BC', value: 'British Columbia', label: 'British Columbia'},
    {code: 'MB', value: 'Manitoba', label: 'Manitoba'},
    {code: 'NB', value: 'New Brunswick', label: 'New Brunswick'},
    {
      code: 'NL',
      value: 'Newfoundland and Labrador',
      label: 'Newfoundland and Labrador',
    },
    {
      code: 'NT',
      value: 'Northwest Territories',
      label: 'Northwest Territories',
    },
    {code: 'NS', value: 'Nova Scotia', label: 'Nova Scotia'},
    {code: 'NU', value: 'Nunavut', label: 'Nunavut'},
    {code: 'ON', value: 'Ontario', label: 'Ontario'},
    {
      code: 'PE',
      value: 'Prince Edward Island',
      label: 'Prince Edward Island',
    },
    {code: 'QC', value: 'Quebec', label: 'Quebec'},
    {code: 'SK', value: 'Saskatchewan', label: 'Saskatchewan'},
    {code: 'YT', value: 'Yukon Territory', label: 'Yukon Territory'},
  ],
  us: [
    {code: 'AL', value: 'Alabama', label: 'Alabama'},
    {code: 'AK', value: 'Alaska', label: 'Alaska'},
    {code: 'AS', value: 'American Samoa', label: 'American Samoa'},
    {code: 'AZ', value: 'Arizona', label: 'Arizona'},
    {code: 'AR', value: 'Arkansas', label: 'Arkansas'},
    {code: 'CA', value: 'California', label: 'California'},
    {code: 'CO', value: 'Colorado', label: 'Colorado'},
    {code: 'CT', value: 'Connecticut', label: 'Connecticut'},
    {code: 'DE', value: 'Delaware', label: 'Delaware'},
    {
      code: 'DC',
      value: 'District Of Columbia',
      label: 'District Of Columbia',
    },
    {
      code: 'FM',
      value: 'Federated States Of Micronesia',
      label: 'Federated States Of Micronesia',
    },
    {code: 'FL', value: 'Florida', label: 'Florida'},
    {code: 'GA', value: 'Georgia', label: 'Georgia'},
    {code: 'GU', value: 'Guam', label: 'Guam'},
    {code: 'HI', value: 'Hawaii', label: 'Hawaii'},
    {code: 'ID', value: 'Idaho', label: 'Idaho'},
    {code: 'IL', value: 'Illinois', label: 'Illinois'},
    {code: 'IN', value: 'Indiana', label: 'Indiana'},
    {code: 'IA', value: 'Iowa', label: 'Iowa'},
    {code: 'KS', value: 'Kansas', label: 'Kansas'},
    {code: 'KY', value: 'Kentucky', label: 'Kentucky'},
    {code: 'LA', value: 'Louisiana', label: 'Louisiana'},
    {code: 'ME', value: 'Maine', label: 'Maine'},
    {code: 'MH', value: 'Marshall Islands', label: 'Marshall Islands'},
    {code: 'MD', value: 'Maryland', label: 'Maryland'},
    {code: 'MA', value: 'Massachusetts', label: 'Massachusetts'},
    {code: 'MI', value: 'Michigan', label: 'Michigan'},
    {code: 'MN', value: 'Minnesota', label: 'Minnesota'},
    {code: 'MS', value: 'Mississippi', label: 'Mississippi'},
    {code: 'MO', value: 'Missouri', label: 'Missouri'},
    {code: 'MT', value: 'Montana', label: 'Montana'},
    {code: 'NE', value: 'Nebraska', label: 'Nebraska'},
    {code: 'NV', value: 'Nevada', label: 'Nevada'},
    {code: 'NH', value: 'New Hampshire', label: 'New Hampshire'},
    {code: 'NJ', value: 'New Jersey', label: 'New Jersey'},
    {code: 'NM', value: 'New Mexico', label: 'New Mexico'},
    {code: 'NY', value: 'New York', label: 'New York'},
    {code: 'NC', value: 'North Carolina', label: 'North Carolina'},
    {code: 'ND', value: 'North Dakota', label: 'North Dakota'},
    {
      code: 'MP',
      value: 'Northern Mariana Islands',
      label: 'Northern Mariana Islands',
    },
    {code: 'OH', value: 'Ohio', label: 'Ohio'},
    {code: 'OK', value: 'Oklahoma', label: 'Oklahoma'},
    {code: 'OR', value: 'Oregon', label: 'Oregon'},
    {code: 'PW', value: 'Palau', label: 'Palau'},
    {code: 'PA', value: 'Pennsylvania', label: 'Pennsylvania'},
    {code: 'PR', value: 'Puerto Rico', label: 'Puerto Rico'},
    {code: 'RI', value: 'Rhode Island', label: 'Rhode Island'},
    {code: 'SC', value: 'South Carolina', label: 'South Carolina'},
    {code: 'SD', value: 'South Dakota', label: 'South Dakota'},
    {code: 'TN', value: 'Tennessee', label: 'Tennessee'},
    {code: 'TX', value: 'Texas', label: 'Texas'},
    {code: 'UT', value: 'Utah', label: 'Utah'},
    {code: 'VT', value: 'Vermont', label: 'Vermont'},
    {code: 'VI', value: 'Virgin Islands', label: 'Virgin Islands'},
    {code: 'VA', value: 'Virginia', label: 'Virginia'},
    {code: 'WA', value: 'Washington', label: 'Washington'},
    {code: 'WV', value: 'West Virginia', label: 'West Virginia'},
    {code: 'WI', value: 'Wisconsin', label: 'Wisconsin'},
    {code: 'WY', value: 'Wyoming', label: 'Wyoming'},
  ],
}

export const languageOptions = [
  {value: 'aa', label: 'Afar'},
  {value: 'ab', label: 'Abkhazian'},
  {value: 'af', label: 'Afrikaans'},
  {value: 'ak', label: 'Akan'},
  {value: 'am', label: 'Amharic'},
  {value: 'an', label: 'Aragonese'},
  {value: 'ar', label: 'Arabic'},
  {value: 'as', label: 'Assamese'},
  {value: 'av', label: 'Avar'},
  {value: 'ay', label: 'Aymara'},
  {value: 'az', label: 'Azerbaijani'},
  {value: 'ba', label: 'Bashkir'},
  {value: 'be', label: 'Belarusian'},
  {value: 'bg', label: 'Bulgarian'},
  {value: 'bh', label: 'Bihari'},
  {value: 'bi', label: 'Bislama'},
  {value: 'bm', label: 'Bambara'},
  {value: 'bn', label: 'Bengali'},
  {value: 'bo', label: 'Tibetan'},
  {value: 'br', label: 'Breton'},
  {value: 'bs', label: 'Bosnian'},
  {value: 'ca', label: 'Catalan'},
  {value: 'ce', label: 'Chechen'},
  {value: 'ch', label: 'Chamorro'},
  {value: 'co', label: 'Corsican'},
  {value: 'cr', label: 'Cree'},
  {value: 'cs', label: 'Czech'},
  {value: 'cu', label: 'Old Church Slavonic / Old Bulgarian'},
  {value: 'cv', label: 'Chuvash'},
  {value: 'cy', label: 'Welsh'},
  {value: 'da', label: 'Danish'},
  {value: 'de', label: 'German'},
  {value: 'dv', label: 'Divehi'},
  {value: 'dz', label: 'Dzongkha'},
  {value: 'ee', label: 'Ewe'},
  {value: 'el', label: 'Greek'},
  {value: 'en', label: 'English'},
  {value: 'eo', label: 'Esperanto'},
  {value: 'es', label: 'Spanish'},
  {value: 'et', label: 'Estonian'},
  {value: 'eu', label: 'Basque'},
  {value: 'fa', label: 'Persian'},
  {value: 'ff', label: 'Peul'},
  {value: 'fi', label: 'Finnish'},
  {value: 'fj', label: 'Fijian'},
  {value: 'fo', label: 'Faroese'},
  {value: 'fr', label: 'French'},
  {value: 'fy', label: 'West Frisian'},
  {value: 'ga', label: 'Irish'},
  {value: 'gd', label: 'Scottish Gaelic'},
  {value: 'gl', label: 'Galician'},
  {value: 'gn', label: 'Guarani'},
  {value: 'gu', label: 'Gujarati'},
  {value: 'gv', label: 'Manx'},
  {value: 'ha', label: 'Hausa'},
  {value: 'he', label: 'Hebrew'},
  {value: 'hi', label: 'Hindi'},
  {value: 'ho', label: 'Hiri Motu'},
  {value: 'hr', label: 'Croatian'},
  {value: 'ht', label: 'Haitian'},
  {value: 'hu', label: 'Hungarian'},
  {value: 'hy', label: 'Armenian'},
  {value: 'hz', label: 'Herero'},
  {value: 'ia', label: 'Interlingua'},
  {value: 'id', label: 'Indonesian'},
  {value: 'ie', label: 'Interlingue'},
  {value: 'ig', label: 'Igbo'},
  {value: 'ii', label: 'Sichuan Yi'},
  {value: 'ik', label: 'Inupiak'},
  {value: 'io', label: 'Ido'},
  {value: 'is', label: 'Icelandic'},
  {value: 'it', label: 'Italian'},
  {value: 'iu', label: 'Inuktitut'},
  {value: 'ja', label: 'Japanese'},
  {value: 'jv', label: 'Javanese'},
  {value: 'ka', label: 'Georgian'},
  {value: 'kg', label: 'Kongo'},
  {value: 'ki', label: 'Kikuyu'},
  {value: 'kj', label: 'Kuanyama'},
  {value: 'kk', label: 'Kazakh'},
  {value: 'kl', label: 'Greenlandic'},
  {value: 'km', label: 'Cambodian'},
  {value: 'kn', label: 'Kannada'},
  {value: 'ko', label: 'Korean'},
  {value: 'kr', label: 'Kanuri'},
  {value: 'ks', label: 'Kashmiri'},
  {value: 'ku', label: 'Kurdish'},
  {value: 'kv', label: 'Komi'},
  {value: 'kw', label: 'Cornish'},
  {value: 'ky', label: 'Kyrgyz'},
  {value: 'la', label: 'Latin'},
  {value: 'lb', label: 'Luxembourgish'},
  {value: 'lg', label: 'Ganda'},
  {value: 'li', label: 'Limburgian'},
  {value: 'ln', label: 'Lingala'},
  {value: 'lo', label: 'Laotian'},
  {value: 'lt', label: 'Lithuanian'},
  {value: 'lu', label: 'Luba-Katanga'},
  {value: 'lv', label: 'Latvian'},
  {value: 'mg', label: 'Malagasy'},
  {value: 'mh', label: 'Marshallese'},
  {value: 'mi', label: 'Maori'},
  {value: 'mk', label: 'Macedonian'},
  {value: 'ml', label: 'Malayalam'},
  {value: 'mn', label: 'Mongolian'},
  {value: 'mo', label: 'Moldovan'},
  {value: 'mr', label: 'Marathi'},
  {value: 'ms', label: 'Malay'},
  {value: 'mt', label: 'Maltese'},
  {value: 'my', label: 'Burmese'},
  {value: 'na', label: 'Nauruan'},
  {value: 'nb', label: 'Norwegian Bokmål'},
  {value: 'nd', label: 'North Ndebele'},
  {value: 'ne', label: 'Nepali'},
  {value: 'ng', label: 'Ndonga'},
  {value: 'nl', label: 'Dutch'},
  {value: 'nn', label: 'Norwegian Nynorsk'},
  {value: 'no', label: 'Norwegian'},
  {value: 'nr', label: 'South Ndebele'},
  {value: 'nv', label: 'Navajo'},
  {value: 'ny', label: 'Chichewa'},
  {value: 'oc', label: 'Occitan'},
  {value: 'oj', label: 'Ojibwa'},
  {value: 'om', label: 'Oromo'},
  {value: 'or', label: 'Oriya'},
  {value: 'os', label: 'Ossetian / Ossetic'},
  {value: 'pa', label: 'Panjabi / Punjabi'},
  {value: 'pi', label: 'Pali'},
  {value: 'pl', label: 'Polish'},
  {value: 'ps', label: 'Pashto'},
  {value: 'pt', label: 'Portuguese'},
  {value: 'qu', label: 'Quechua'},
  {value: 'rm', label: 'Raeto Romance'},
  {value: 'rn', label: 'Kirundi'},
  {value: 'ro', label: 'Romanian'},
  {value: 'ru', label: 'Russian'},
  {value: 'rw', label: 'Rwandi'},
  {value: 'sa', label: 'Sanskrit'},
  {value: 'sc', label: 'Sardinian'},
  {value: 'sd', label: 'Sindhi'},
  {value: 'se', label: 'Northern Sami'},
  {value: 'sg', label: 'Sango'},
  {value: 'sh', label: 'Serbo-Croatian'},
  {value: 'si', label: 'Sinhalese'},
  {value: 'sk', label: 'Slovak'},
  {value: 'sl', label: 'Slovenian'},
  {value: 'sm', label: 'Samoan'},
  {value: 'sn', label: 'Shona'},
  {value: 'so', label: 'Somalia'},
  {value: 'sq', label: 'Albanian'},
  {value: 'sr', label: 'Serbian'},
  {value: 'ss', label: 'Swati'},
  {value: 'st', label: 'Southern Sotho'},
  {value: 'su', label: 'Sundanese'},
  {value: 'sv', label: 'Swedish'},
  {value: 'sw', label: 'Swahili'},
  {value: 'ta', label: 'Tamil'},
  {value: 'te', label: 'Telugu'},
  {value: 'tg', label: 'Tajik'},
  {value: 'th', label: 'Thai'},
  {value: 'ti', label: 'Tigrinya'},
  {value: 'tk', label: 'Turkmen'},
  {value: 'tl', label: 'Tagalog / Filipino'},
  {value: 'tn', label: 'Tswana'},
  {value: 'to', label: 'Tonga'},
  {value: 'tr', label: 'Turkish'},
  {value: 'ts', label: 'Tsonga'},
  {value: 'tt', label: 'Tatar'},
  {value: 'tw', label: 'Twi'},
  {value: 'ty', label: 'Tahitian'},
  {value: 'ug', label: 'Uyghur'},
  {value: 'uk', label: 'Ukrainian'},
  {value: 'ur', label: 'Urdu'},
  {value: 'uz', label: 'Uzbek'},
  {value: 've', label: 'Venda'},
  {value: 'vi', label: 'Vietnamese'},
  {value: 'vo', label: 'Volapük'},
  {value: 'wa', label: 'Walloon'},
  {value: 'wo', label: 'Wolof'},
  {value: 'xh', label: 'Xhosa'},
  {value: 'yi', label: 'Yiddish'},
  {value: 'yo', label: 'Yoruba'},
  {value: 'za', label: 'Zhuang'},
  {value: 'zh', label: 'Chinese'},
  {value: 'zu', label: 'Zulu'},
]

export const privacyOptions = (region: string, brand: string) =>
  region === 'nafta' && brand !== 'maserati'
    ? [{value: true, label: 'I Accept'}]
    : [
      {value: true, label: 'I Accept'},
      {value: false, label: 'I Decline'},
    ]

export const civilityOptions = [
  {
    value: 'MR',
    label: 'M.',
  },
  {
    value: 'MRS',
    label: 'Mme',
  },
  {
    value: 'MISS',
    label: 'Mlle',
  },
  {
    value: 'MS',
    label: 'Mme',
  },
  {
    value: 'OTHER',
    label: 'Autre',
  },
]

export const unitOptions = [{
  value: 'Metric',
  label: 'km/L/C°/KPA'
}, {
  value: 'Imperial UK',
  label: 'Miles/Gals/°F UK/BAR'
}, {
  value: 'Imperial US',
  label: 'Miles/Gals/°F US/PSI'
}]

export const live_sites: LiveCountryList = {
  live_countries: {
    "GB": ["EN"],
    "AT": ["DE"],
    "BE": ["FR", "NL"],
    "BG": ["EN"],
    "HR": ["EN"],
    "CY": ["EN"],
    "CZ": ["CS"],
    "DK": ["DA"],
    "EE": ["EN"],
    "FI": ["FI"],
    "FR": ["FR"],
    "DE": ["DE"],
    "GR": ["EL"],
    "HU": ["HU"],
    "IE": ["EN"],
    "IT": ["IT"],
    "LV": ["EN"],
    "LT": ["EN"],
    "LU": ["FR"],
    "MT": ["EN"],
    "NL": ["NL"],
    "PL": ["PL"],
    "PT": ["PT"],
    "RO": ["EN"],
    "SK": ["SK"],
    "SI": ["EN"],
    "ES": ["ES"],
    "SE": ["SV"],
    "IS": ["EN"],
    "LI": ["DE"],
    "NO": ["NO"],
    "CH": ["IT", "DE", "FR"],
    "US": ["EN", "FR", "ES"],
    "CA": ["EN", "FR", "ES"],
    "BR": ["PT", "EN"],
    "AU": ["EN"],
    "KR": ["EN", "KO"],
    "JP": ["EN", "JA"],
    "IN": ["EN"]
  }
}

export const prefixes_list: PrefixesList = {
  ad: {
    value: "376",
    label: "AD(+376)"
  },
  ae: {
    value: "971",
    label: "AE(+971)"
  },
  af: {
    value: "93",
    label: "AF(+93)"
  },
  ag: {
    value: "1-268",
    label: "AG(+1-268)"
  },
  ai: {
    value: "1-264",
    label: "AI(+1-264)"
  },
  al: {
    value: "355",
    label: "AL(+355)"
  },
  am: {
    value: "374",
    label: "AM(+374)"
  },
  ao: {
    value: "244",
    label: "AO(+244)"
  },
  aq: {
    value: "672",
    label: "AQ(+672)"
  },
  ar: {
    value: "54",
    label: "AR(+54)"
  },
  as: {
    value: "1-684",
    label: "AS(+1-684)"
  },
  at: {
    value: "43",
    label: "AT(+43)"
  },
  au: {
    value: "61",
    label: "AU(+61)"
  },
  aw: {
    value: "297",
    label: "AW(+297)"
  },
  ax: {
    value: "358",
    label: "AX(+358)"
  },
  az: {
    value: "994",
    label: "AZ(+994)"
  },
  ba: {
    value: "387",
    label: "BA(+387)"
  },
  bb: {
    value: "1-246",
    label: "BB(+1-246)"
  },
  bd: {
    value: "880",
    label: "BD(+880)"
  },
  be: {
    value: "32",
    label: "BE(+32)"
  },
  bf: {
    value: "226",
    label: "BF(+226)"
  },
  bg: {
    value: "359",
    label: "BG(+359)"
  },
  bh: {
    value: "973",
    label: "BH(+973)"
  },
  bi: {
    value: "257",
    label: "BI(+257)"
  },
  bj: {
    value: "229",
    label: "BJ(+229)"
  },
  bl: {
    value: "590",
    label: "BL(+590)"
  },
  bm: {
    value: "1-441",
    label: "BM(+1-441)"
  },
  bn: {
    value: "673",
    label: "BN(+673)"
  },
  bo: {
    value: "591",
    label: "BO(+591)"
  },
  bq: {
    value: "599",
    label: "BQ(+599)"
  },
  br: {
    value: "55",
    label: "BR(+55)"
  },
  bs: {
    value: "1-242",
    label: "BS(+1-242)"
  },
  bt: {
    value: "975",
    label: "BT(+975)"
  },
  bv: {
    value: "47",
    label: "BV(+47)"
  },
  bw: {
    value: "267",
    label: "BW(+267)"
  },
  by: {
    value: "375",
    label: "BY(+375)"
  },
  bz: {
    value: "501",
    label: "BZ(+501)"
  },
  ca: {
    value: "1",
    label: "US/CA(+1)"
  },
  cc: {
    value: "61",
    label: "CC(+61)"
  },
  cd: {
    value: "243",
    label: "CD(+243)"
  },
  cf: {
    value: "236",
    label: "CF(+236)"
  },
  cg: {
    value: "242",
    label: "CG(+242)"
  },
  ch: {
    value: "41",
    label: "CH(+41)"
  },
  ci: {
    value: "225",
    label: "CI(+225)"
  },
  ck: {
    value: "682",
    label: "CK(+682)"
  },
  cl: {
    value: "56",
    label: "CL(+56)"
  },
  cm: {
    value: "237",
    label: "CM(+237)"
  },
  cn: {
    value: "86",
    label: "CN(+86)"
  },
  co: {
    value: "57",
    label: "CO(+57)"
  },
  cr: {
    value: "506",
    label: "CR(+506)"
  },
  cu: {
    value: "53",
    label: "CU(+53)"
  },
  cv: {
    value: "238",
    label: "CV(+238)"
  },
  cw: {
    value: "599",
    label: "CW(+599)"
  },
  cx: {
    value: "61",
    label: "CX(+61)"
  },
  cy: {
    value: "357",
    label: "CY(+357)"
  },
  cz: {
    value: "420",
    label: "CZ(+420)"
  },
  de: {
    value: "49",
    label: "DE(+49)"
  },
  dj: {
    value: "253",
    label: "DJ(+253)"
  },
  dk: {
    value: "45",
    label: "DK(+45)"
  },
  dm: {
    value: "1-767",
    label: "DM(+1-767)"
  },
  do: {
    value: "1-809,1-829,1-849",
    label: "DO(+1-809,1-829,1-849)"
  },
  dz: {
    value: "213",
    label: "DZ(+213)"
  },
  ec: {
    value: "593",
    label: "EC(+593)"
  },
  ee: {
    value: "372",
    label: "EE(+372)"
  },
  eg: {
    value: "20",
    label: "EG(+20)"
  },
  eh: {
    value: "212",
    label: "EH(+212)"
  },
  er: {
    value: "291",
    label: "ER(+291)"
  },
  es: {
    value: "34",
    label: "ES(+34)"
  },
  et: {
    value: "251",
    label: "ET(+251)"
  },
  fi: {
    value: "358",
    label: "FI(+358)"
  },
  fj: {
    value: "679",
    label: "FJ(+679)"
  },
  fk: {
    value: "500",
    label: "FK(+500)"
  },
  fm: {
    value: "691",
    label: "FM(+691)"
  },
  fo: {
    value: "298",
    label: "FO(+298)"
  },
  fr: {
    value: "33",
    label: "FR(+33)"
  },
  ga: {
    value: "241",
    label: "GA(+241)"
  },
  gb: {
    value: "44",
    label: "GB(+44)"
  },
  gd: {
    value: "1-473",
    label: "GD(+1-473)"
  },
  ge: {
    value: "995",
    label: "GE(+995)"
  },
  gf: {
    value: "594",
    label: "GF(+594)"
  },
  gg: {
    value: "44",
    label: "GG(+44)"
  },
  gh: {
    value: "233",
    label: "GH(+233)"
  },
  gi: {
    value: "350",
    label: "GI(+350)"
  },
  gl: {
    value: "299",
    label: "GL(+299)"
  },
  gm: {
    value: "220",
    label: "GM(+220)"
  },
  gn: {
    value: "224",
    label: "GN(+224)"
  },
  gp: {
    value: "590",
    label: "GP(+590)"
  },
  gq: {
    value: "240",
    label: "GQ(+240)"
  },
  gr: {
    value: "30",
    label: "GR(+30)"
  },
  gs: {
    value: "500",
    label: "GS(+500)"
  },
  gt: {
    value: "502",
    label: "GT(+502)"
  },
  gu: {
    value: "1-671",
    label: "GU(+1-671)"
  },
  gw: {
    value: "245",
    label: "GW(+245)"
  },
  gy: {
    value: "592",
    label: "GY(+592)"
  },
  hk: {
    value: "852",
    label: "HK(+852)"
  },
  hm: {
    value: "672",
    label: "HM(+672)"
  },
  hn: {
    value: "504",
    label: "HN(+504)"
  },
  hr: {
    value: "385",
    label: "HR(+385)"
  },
  ht: {
    value: "509",
    label: "HT(+509)"
  },
  hu: {
    value: "36",
    label: "HU(+36)"
  },
  id: {
    value: "62",
    label: "ID(+62)"
  },
  ie: {
    value: "353",
    label: "IE(+353)"
  },
  il: {
    value: "972",
    label: "IL(+972)"
  },
  im: {
    value: "44",
    label: "IM(+44)"
  },
  in: {
    value: "91",
    label: "IN(+91)"
  },
  io: {
    value: "246",
    label: "IO(+246)"
  },
  iq: {
    value: "964",
    label: "IQ(+964)"
  },
  ir: {
    value: "98",
    label: "IR(+98)"
  },
  is: {
    value: "354",
    label: "IS(+354)"
  },
  it: {
    value: "39",
    label: "IT(+39)"
  },
  je: {
    value: "44",
    label: "JE(+44)"
  },
  jm: {
    value: "1-876",
    label: "JM(+1-876)"
  },
  jo: {
    value: "962",
    label: "JO(+962)"
  },
  jp: {
    value: "81",
    label: "JP(+81)"
  },
  ke: {
    value: "254",
    label: "KE(+254)"
  },
  kg: {
    value: "996",
    label: "KG(+996)"
  },
  kh: {
    value: "855",
    label: "KH(+855)"
  },
  ki: {
    value: "686",
    label: "KI(+686)"
  },
  km: {
    value: "269",
    label: "KM(+269)"
  },
  kn: {
    value: "1-869",
    label: "KN(+1-869)"
  },
  kp: {
    value: "850",
    label: "KP(+850)"
  },
  kr: {
    value: "82",
    label: "KR(+82)"
  },
  kw: {
    value: "965",
    label: "KW(+965)"
  },
  ky: {
    value: "1-345",
    label: "KY(+1-345)"
  },
  kz: {
    value: "7",
    label: "KZ(+7)"
  },
  la: {
    value: "856",
    label: "LA(+856)"
  },
  lb: {
    value: "961",
    label: "LB(+961)"
  },
  lc: {
    value: "1-758",
    label: "LC(+1-758)"
  },
  li: {
    value: "423",
    label: "LI(+423)"
  },
  lk: {
    value: "94",
    label: "LK(+94)"
  },
  lr: {
    value: "231",
    label: "LR(+231)"
  },
  ls: {
    value: "266",
    label: "LS(+266)"
  },
  lt: {
    value: "370",
    label: "LT(+370)"
  },
  lu: {
    value: "352",
    label: "LU(+352)"
  },
  lv: {
    value: "371",
    label: "LV(+371)"
  },
  ly: {
    value: "218",
    label: "LY(+218)"
  },
  ma: {
    value: "212",
    label: "MA(+212)"
  },
  mc: {
    value: "377",
    label: "MC(+377)"
  },
  md: {
    value: "373",
    label: "MD(+373)"
  },
  me: {
    value: "382",
    label: "ME(+382)"
  },
  mf: {
    value: "590",
    label: "MF(+590)"
  },
  mg: {
    value: "261",
    label: "MG(+261)"
  },
  mh: {
    value: "692",
    label: "MH(+692)"
  },
  mk: {
    value: "389",
    label: "MK(+389)"
  },
  ml: {
    value: "223",
    label: "ML(+223)"
  },
  mm: {
    value: "95",
    label: "MM(+95)"
  },
  mn: {
    value: "976",
    label: "MN(+976)"
  },
  mo: {
    value: "853",
    label: "MO(+853)"
  },
  mp: {
    value: "1-670",
    label: "MP(+1-670)"
  },
  mq: {
    value: "596",
    label: "MQ(+596)"
  },
  mr: {
    value: "222",
    label: "MR(+222)"
  },
  ms: {
    value: "1-664",
    label: "MS(+1-664)"
  },
  mt: {
    value: "356",
    label: "MT(+356)"
  },
  mu: {
    value: "230",
    label: "MU(+230)"
  },
  mv: {
    value: "960",
    label: "MV(+960)"
  },
  mw: {
    value: "265",
    label: "MW(+265)"
  },
  mx: {
    value: "52",
    label: "MX(+52)"
  },
  my: {
    value: "60",
    label: "MY(+60)"
  },
  mz: {
    value: "258",
    label: "MZ(+258)"
  },
  nc: {
    value: "687",
    label: "NC(+687)"
  },
  ne: {
    value: "227",
    label: "NE(+227)"
  },
  nf: {
    value: "672",
    label: "NF(+672)"
  },
  ng: {
    value: "234",
    label: "NG(+234)"
  },
  ni: {
    value: "505",
    label: "NI(+505)"
  },
  nl: {
    value: "31",
    label: "NL(+31)"
  },
  no: {
    value: "47",
    label: "NO(+47)"
  },
  np: {
    value: "977",
    label: "NP(+977)"
  },
  nr: {
    value: "674",
    label: "NR(+674)"
  },
  nu: {
    value: "683",
    label: "NU(+683)"
  },
  nz: {
    value: "64",
    label: "NZ(+64)"
  },
  om: {
    value: "968",
    label: "OM(+968)"
  },
  pa: {
    value: "507",
    label: "PA(+507)"
  },
  pe: {
    value: "51",
    label: "PE(+51)"
  },
  pf: {
    value: "689",
    label: "PF(+689)"
  },
  pg: {
    value: "675",
    label: "PG(+675)"
  },
  ph: {
    value: "63",
    label: "PH(+63)"
  },
  pk: {
    value: "92",
    label: "PK(+92)"
  },
  pl: {
    value: "48",
    label: "PL(+48)"
  },
  pm: {
    value: "508",
    label: "PM(+508)"
  },
  pn: {
    value: "870",
    label: "PN(+870)"
  },
  pr: {
    value: "1",
    label: "PR(+1)"
  },
  ps: {
    value: "970",
    label: "PS(+970)"
  },
  pt: {
    value: "351",
    label: "PT(+351)"
  },
  pw: {
    value: "680",
    label: "PW(+680)"
  },
  py: {
    value: "595",
    label: "PY(+595)"
  },
  qa: {
    value: "974",
    label: "QA(+974)"
  },
  re: {
    value: "262",
    label: "RE(+262)"
  },
  ro: {
    value: "40",
    label: "RO(+40)"
  },
  rs: {
    value: "381 p",
    label: "RS(+381 p)"
  },
  ru: {
    value: "7",
    label: "RU(+7)"
  },
  rw: {
    value: "250",
    label: "RW(+250)"
  },
  sa: {
    value: "966",
    label: "SA(+966)"
  },
  sb: {
    value: "677",
    label: "SB(+677)"
  },
  sc: {
    value: "248",
    label: "SC(+248)"
  },
  sd: {
    value: "249",
    label: "SD(+249)"
  },
  se: {
    value: "46",
    label: "SE(+46)"
  },
  sg: {
    value: "65",
    label: "SG(+65)"
  },
  sh: {
    value: "290 n",
    label: "SH(+290 n)"
  },
  si: {
    value: "386",
    label: "SI(+386)"
  },
  sj: {
    value: "47",
    label: "SJ(+47)"
  },
  sk: {
    value: "421",
    label: "SK(+421)"
  },
  sl: {
    value: "232",
    label: "SL(+232)"
  },
  sm: {
    value: "378",
    label: "SM(+378)"
  },
  sn: {
    value: "221",
    label: "SN(+221)"
  },
  so: {
    value: "252",
    label: "SO(+252)"
  },
  sr: {
    value: "597",
    label: "SR(+597)"
  },
  ss: {
    value: "211",
    label: "SS(+211)"
  },
  st: {
    value: "239",
    label: "ST(+239)"
  },
  sv: {
    value: "503",
    label: "SV(+503)"
  },
  sx: {
    value: "1-721",
    label: "SX(+1-721)"
  },
  sy: {
    value: "963",
    label: "SY(+963)"
  },
  sz: {
    value: "268",
    label: "SZ(+268)"
  },
  tc: {
    value: "1-649",
    label: "TC(+1-649)"
  },
  td: {
    value: "235",
    label: "TD(+235)"
  },
  tf: {
    value: "262",
    label: "TF(+262)"
  },
  tg: {
    value: "228",
    label: "TG(+228)"
  },
  th: {
    value: "66",
    label: "TH(+66)"
  },
  tj: {
    value: "992",
    label: "TJ(+992)"
  },
  tk: {
    value: "690",
    label: "TK(+690)"
  },
  tl: {
    value: "670",
    label: "TL(+670)"
  },
  tm: {
    value: "993",
    label: "TM(+993)"
  },
  tn: {
    value: "216",
    label: "TN(+216)"
  },
  to: {
    value: "676",
    label: "TO(+676)"
  },
  tr: {
    value: "90",
    label: "TR(+90)"
  },
  tt: {
    value: "1-868",
    label: "TT(+1-868)"
  },
  tv: {
    value: "688",
    label: "TV(+688)"
  },
  tw: {
    value: "886",
    label: "TW(+886)"
  },
  tz: {
    value: "255",
    label: "TZ(+255)"
  },
  ua: {
    value: "380",
    label: "UA(+380)"
  },
  ug: {
    value: "256",
    label: "UG(+256)"
  },
  us: {
    value: "1",
    label: "US/CA(+1)"
  },
  uy: {
    value: "598",
    label: "UY(+598)"
  },
  uz: {
    value: "998",
    label: "UZ(+998)"
  },
  va: {
    value: "39-06",
    label: "VA(+39-06)"
  },
  vc: {
    value: "1-784",
    label: "VC(+1-784)"
  },
  ve: {
    value: "58",
    label: "VE(+58)"
  },
  vg: {
    value: "1-284",
    label: "VG(+1-284)"
  },
  vi: {
    value: "1-340",
    label: "VI(+1-340)"
  },
  vn: {
    value: "84",
    label: "VN(+84)"
  },
  vu: {
    value: "678",
    label: "VU(+678)"
  },
  wf: {
    value: "681",
    label: "WF(+681)"
  },
  ws: {
    value: "685",
    label: "WS(+685)"
  },
  ye: {
    value: "967",
    label: "YE(+967)"
  },
  yt: {
    value: "262",
    label: "YT(+262)"
  },
  za: {
    value: "27",
    label: "ZA(+27)"
  },
  zm: {
    value: "260",
    label: "ZM(+260)"
  },
  zw: {
    value: "263",
    label: "ZW(+263)"
  }
}

export const forms = (region: string, brand: string) => ({
  serverErrorLogin: 'Invalid login or password',
  fields: [
    // ------------
    // ------------
    // Basic Fields
    // ------------
    // ------------
    {
      id: 'firstName',
      regex: '',
      label: 'First Name:*',
      title: 'First Name',
      ariaLabel: 'First Name',
      messages: {
        info: '',
        success: '',
        pattern:
          'First Name must contain only letters and be longer than 2 characters',
        required: 'The first name field is required',
      },
    },
    {
      id: 'lastName',
      regex: '',
      label: 'Surname:*',
      title: 'Surname',
      ariaLabel: 'Surname',
      messages: {
        info: '',
        success: '',
        pattern:
          'Last Name must contain only letters and be longer than 2 characters',
        required: 'The last name field is required',
      },
    },
    {
      id: 'civility_code',
      regex: '',
      label: 'Salutation',
      title: 'Salutation',
      ariaLabel: 'Salutation',
      messages: {
        info: '',
        success: '',
        pattern: 'Salutation format is not valid',
        required: 'The Salutation field is required',
      },
    },
    {
      id: 'zip',
      regex: '',
      label: 'Postal Code',
      title: 'Zip Code',
      ariaLabel: 'Zip Code',
      messages: {
        info: '',
        success: '',
        pattern: 'The zip code format is not valid',
        required: 'The zip code field is required',
      },
    },
    {
      id: 'address',
      regex: '',
      label: 'Street address and house number',
      title: 'Street address and house number',
      ariaLabel: 'Street address and house number',
      messages: {
        info: '',
        success: '',
        pattern: 'The street address and house number format is not valid',
        required: 'The treet address and house number field is required',
      },
    },
    {
      id: 'address1',
      regex: '',
      label: 'Street address and house nunber',
      title: 'Street address and house nunber',
      ariaLabel: 'Street address and house nunber',
      messages: {
        info: '',
        success: '',
        pattern: 'The street address format is not valid',
        required: 'The street address field is required',
      },
    },
    {
      id: 'address1',
      regex: '',
      label: 'Street address and house nunber',
      title: 'Street address and house nunber',
      ariaLabel: 'Street address and house nunber',
      messages: {
        info: '',
        success: '',
        pattern: 'The street address format is not valid',
        required: 'The street address field is required',
      },
    },
    {
      id: 'address1',
      regex: '',
      label: 'Street address and house nunber',
      title: 'Street address and house nunber',
      ariaLabel: 'Street address and house nunber',
      messages: {
        info: '',
        success: '',
        pattern: 'The street address format is not valid',
        required: 'The street address field is required',
      },
    },
    {
      id: 'city',
      regex: '',
      label: 'City',
      title: 'City',
      ariaLabel: 'City',
      messages: {
        info: '',
        success: '',
        pattern: 'The city format is not valid',
        required: 'The city field is required',
      },
    },
    {
      id: 'state',
      regex: '',
      label: region == 'emea' ? 'State' : 'Region/State/Provinces',
      title: 'State',
      ariaLabel: 'State',
      messages: {
        info: '',
        success: '',
        pattern: 'The state format is not valid',
        required: 'The state field is required',
      },
    },
    {
      id: 'CPF_CNPJ',
      regex: '',
      label: '',
      title: 'CPF/CNPJ',
      ariaLabel: 'CPF/CNPJ',
      messages: {
        info: '',
        success: '',
        pattern: 'The text format is not valid',
        required: 'The text field is required',
      },
    },
    {
      id: 'HouseNumber',
      regex: '',
      label: 'House Number',
      title: 'House Number',
      ariaLabel: 'House Number',
      messages: {
        info: '',
        success: '',
        pattern: 'The house number format is not valid',
        required: 'The house number field is required',
      },
    },
    {
      id: 'county',
      regex: '',
      label: 'Neighborhood',
      title: 'Neighborhood',
      ariaLabel: 'Neighborhood',
      messages: {
        info: '',
        success: '',
        pattern: 'The neighborhood format is not valid',
        required: 'The neighborhood field is required',
      },
    },
    {
      id: 'address2',
      regex: '',
      label: 'Apt, Suite, Building, Floor, etc',
      title: 'Apt, Suite, Building, Floor, etc',
      ariaLabel: 'Apt, Suite, Building, Floor, etc',
      messages: {
        info: '',
        success: '',
        pattern: 'The address format is not valid',
        required: 'The address field is required',
      },
    },
    {
      id: 'phoneNumber',
      regex: '',
      label: 'Phone Number',
      title: 'Phone Number',
      ariaLabel: 'Phone Number',
      messages: {
        info: '',
        success: '',
        pattern: 'The phone number format is not valid',
        required: 'The phone number field is required',
      },
    },
    {
      id: 'numberMobile',
      regex: '',
      label: 'Mobile Number',
      title: 'Mobile Phone Number',
      ariaLabel: 'Mobile Phone Number',
      messages: {
        info: '',
        success: '',
        pattern: 'The mobile phone number format is not valid',
        required: 'The mobile phone number field is required',
      },
    },
    {
      id: 'numberHome',
      regex: '',
      label: 'Home Phone Number',
      title: 'Home Phone Number',
      ariaLabel: 'Home Phone Number',
      messages: {
        info: '',
        success: '',
        pattern: 'The home phone number format is not valid',
        required: 'The home phone number field is required',
      },
    },
    // GROUPS of Fields
    // -----------------
    {
      id: 'mobileNumberGroup',
      label: 'Prefix and Phone number',
      title: 'Phone Number',
      ariaLabel: 'Phone Number',
      messages: {
        info: '',
        success: '',
        pattern: 'The phone number prefix format is not valid',
        required: 'The phone number prefix field is required',
      },
    },
    {
      id: 'homeNumberGroup',
      label: 'Prefix and Home Phone Number',
      title: 'Home Phone Number',
      ariaLabel: 'Home Phone Number',
      messages: {
        info: '',
        success: '',
        pattern: 'The Home phone number prefix format is not valid',
        required: 'The Home phone number prefix field is required',
      },
    },
    // Select/Dropdown Fields
    // -----------------------
    {
      id: 'country',
      label: 'Country:*',
      title: 'Country',
      ariaLabel: 'Country',
      messages: {
        info: '',
        success: '',
        pattern: 'The country format is not valid',
        required: 'The country field is required',
      },
    },
    {
      id: 'locale',
      label: 'Language:*',
      title: 'Language',
      ariaLabel: 'Language',
      messages: {
        info: '',
        success: '',
        pattern: 'The language format is not valid',
        required: 'The language field is required',
      },
    },
    {
      id: 'unitPreferences',
      label: '',
      title: 'Select Website Preferences',
      ariaLabel: 'Select Website Preferences',
    },
    {
      id: 'prefixMobile',
      label: 'Prefix:*',
      title: 'Mobile Phone Number prefix',
      ariaLabel: 'Mobile Phone Number prefix',
      messages: {
        info: '',
        success: '',
        pattern: 'The mobile phone number prefix format is not valid',
        required: 'The mobile phone number prefix field is required',
      },
    },
    {
      id: 'prefixHome',
      label: 'Prefix:*',
      title: 'Home Phone Number prefix',
      ariaLabel: 'Home Phone Number prefix',
      messages: {
        info: '',
        success: '',
        pattern: 'The Home phone number prefix format is not valid',
        required: 'The Home phone number prefix field is required',
      },
    },

    // ----------------
    // ----------------
    // Email Fields
    // ----------------
    // ----------------
    {
      id: 'email',
      regex: '',
      label: 'Email',
      title: 'Email',
      ariaLabel: 'Email',
      messages: {
        info: '',
        success: '',
        pattern: 'The email format is not valid',
        required: 'The email field is required',
        emailNotAvailable: '',
      },
    },

    // ----------------
    // ----------------
    // Password Fields
    // ----------------
    // ----------------
    {
      id: 'password',
      // regex: '^[^<>+\\\\|\\/*\\?]{8,16}$',
      regex: '',
      label: 'Password',
      title: 'Password',
      ariaLabel: 'Password',
      messages: {
        info: '',
        success: '',
        pattern: 'The password format is not valid',
        required: 'The password field is required',
        passwordMustMatch: 'Passwords must match',
      },
    },
    {
      id: 'new_password',
      regex: '',
      label: 'New Password',
      title: 'New Password',
      ariaLabel: 'New Password',
      messages: {
        info: 'Password must contain 8-16 characters including at least 1 letter, 1 number and 1 special character (@$!%&?_-). Symbols that cannot be used include <>+|/*\\',
        success: 'Password meets the requirements',
        pattern:
          'Password must contain 8-16 characters including at least 1 letter, 1 number and 1 special character (@$!%&?_-). Symbols that cannot be used include <>+|/*\\',
        required: 'This field is required',
        passwordMustMatch: 'Passwords must match',
      },
    },
    {
      id: 'create_password',
      regex: '',
      label: 'Password',
      title: 'Password',
      ariaLabel: 'Password',
      messages: {
        // info: 'Password requirements: can\'t be empty, null, blank; can\'t be composed only by blanks; length must be between 8 and 16 chars (included); can\'t contain following chars <> + | / * ? \\',
        info: 'Password must contain 8-16 characters including at least 1 letter, 1 number and 1 special character (@$!%&?_-). Symbols that cannot be used include <>+|/*\\',
        success: 'Password meets the requirements',
        pattern:
          'Password must contain 8-16 characters including at least 1 letter, 1 number and 1 special character (@$!%&?_-). Symbols that cannot be used include <>+|/*\\',
        required: 'The password field is required',
      },
    },
    {
      id: 'repeat_password',
      regex: '',
      label: 'Repeat Password',
      title: 'Repeat Password',
      ariaLabel: 'Repeat Password',
      messages: {
        info: 'Password must contain 8-16 characters including at least 1 letter, 1 number and 1 special character (@$!%&?_-). Symbols that cannot be used include <>+|/*\\',
        success: 'Password meets the requirements',
        pattern:
          'Password must contain 8-16 characters including at least 1 letter, 1 number and 1 special character (@$!%&?_-). Symbols that cannot be used include <>+|/*\\',
        required: 'This field is required',
        passwordMustMatch: 'Passwords must match',
      },
    },
    {
      id: 'confirm_password',
      regex: '',
      label: 'Confirm Password',
      title: 'Confirm Password',
      ariaLabel: 'Confirm Password',
      messages: {
        info: 'Passwords must match',
        success: 'Passwords match',
        // pattern: 'Password must contain 8-16 characters including letters and numbers. Symbols that cannot be used include <>+|/*? \\',
        pattern: 'Passwords must match!',
        required: 'The confirm password field is required',
        passwordMustMatch: 'Passwords must match',
      },
    },
    {
      id: 'current_password',
      regex: '',
      label: 'Current Password',
      title: 'Current Password',
      ariaLabel: 'Current Password',
      messages: {
        info: 'Password must contain 8-16 characters including at least 1 letter, 1 number and 1 special character (@$!%&?_-). Symbols that cannot be used include <>+|/*\\',
        success: 'Password meets the requirements',
        pattern:
          'Password must contain 8-16 characters including at least 1 letter, 1 number and 1 special character (@$!%&?_-). Symbols that cannot be used include <>+|/*\\',
        required: 'This field is required',
      },
    },

    // ---------------------------
    // ---------------------------
    // Dynamic Fields (with links)
    // ---------------------------
    // ---------------------------
    {
      id: 'marketing',
      label: '{{link1}}',
      links:
        brand === 'maserati'
          ? [
            {
              placeholder: '{{link1}}',
              href: '/privacy.html',
              label:
                'I confirm to the customization of the Services based on my preferences and choices*',
            },
          ]
          : region === 'emea'
            ? [
              {
                placeholder: '{{link1}}',
                href: '/privacy.html',
                label: 'I want to receive offers and promotions from FCA*',
              },
            ]
            : null,
    },
    {
      id: 'profiling',
      label: '{{link1}}',
      links:
        brand === 'maserati'
          ? [
            {
              placeholder: '{{link1}}',
              href: '/privacy.html',
              label:
                'I consent to receive promotional communications and materials*',
            },
          ]
          : region === 'emea'
            ? [
              {
                placeholder: '{{link1}}',
                href: '/privacy.html',
                label:
                  'I would like to help FCA improve services and products with my data*',
              },
            ]
            : null,
    },
    {
      id: 'thirdPartiesMarketing',
      label: '{{link1}}',
      links:
        region === 'emea'
          ? [
            {
              placeholder: '{{link1}}',
              href: '/privacy.html',
              label:
                'I want to receive offers and promotions from FCA partners*',
            },
          ]
          : [
            // latam
            {
              placeholder: '{{link1}}',
              href: '/privacy.html',
              label:
                'I want to receive offers and promotions from partners of FCA',
            },
          ],
    },
    {
      id: 'thirdPartiesProfiling',
      label: '{{link1}}',
      links:
        region === 'emea'
          ? [
            {
              placeholder: '{{link1}}',
              href: '/personal-data-3rd-parties.html',
              label:
                'I want to receive personalised and advantageous offers from FCA partners based on my data (e.g. discount on insurance policy)<br>Note: Click on the text to view the partner list*',
            },
          ]
          : [
            // latam
            {
              placeholder: '{{link1}}',
              href: '/personal-data-3rd-parties.html',
              label: 'Fill out automatically forms from FCA partners',
            },
          ],
    },
    {
      // latam only field
      id: 'thirdPartiesDrivingPersonalData',
      label: '{{link1}}',
      links: [
        {
          placeholder: '{{link1}}',
          href: 'https://aemstagems4-connectivity.jeep.com/br/en/privacy/driving-personal-data-3rd',
          label:
            'I accept to share my data with LexisNexis Soluções de Risco Ltda., including personal data information generated and stored in my vehicle, for development of products related to the vehicle insurance market',
        },
      ],
    },
    // Checkbox Fields
    // ----------------
    {
      id: 'allprivacyconsent',
      // nafta
      label:
        region === 'nafta'
          ? 'I have read and agree to the {{link1}} and {{link2}}'
          : // apac (iap)
          'I have read and agree to the IAP {{link1}} and {{link2}}',
      links: [
        {
          placeholder: '{{link1}}',
          href: '/website-application-terms.html',
          label: 'Website Terms of Use',
        },
        {
          placeholder: '{{link2}}',
          href: '/privacy.html',
          label: 'Privacy Policy',
        },
      ],
    },
    // Custom Fields
    // -- fields not related with inputs field
    // ----------------
    {
      id: 'link_forgot_password',
      label: '{{link}}',
      links: [
        {
          placeholder: '{{link}}',
          href: '../../login/forgot-password',
          label: 'Forgot your password?',
        },
      ],
    },
    // Changing Fields
    // ----------------
    {
      id: 'connectedTerms',
      // emea or maserati
      label:
        region === 'emea' || brand === 'maserati'
          ? 'Connected Service Terms </br>{{link1}}'
          : // nafta
          region === 'nafta'
            ? "I have read and agree to the {{link1}} and {{link2}}<br><small>which govern STELLANTIS LLC's collection use and disclosure of personal information (including geolocation and driving data) and other vehicle data by or through the Connected Services</small>"
            : // apac (iap)
            "I have read and agree to the IAP {{link1}} and {{link2}}<br><small>which govern STELLANTIS LLC's collection use and disclosure of personal information (including geolocation and driving data) and other vehicle data by or through the Connected Services</small>",
      // emea or maserati
      links:
        region === 'emea' || brand === 'maserati'
          ? [
            {
              placeholder: '{{link1}}',
              href: '/website-application-terms.html',
              label: 'Website Terms of Use',
            },
            {
              placeholder: '{{link2}}',
              href: '/privacy.html',
              label: 'Privacy Policy',
            },
          ]
          : [
            // nafta or apac (iap)
            {
              placeholder: '{{link1}}',
              href: '/terms-and-conditions.html',
              label: 'Connected Services Terms of Services',
            },
            {
              placeholder: '{{link2}}',
              href: '/connected-services-privacy-policy.html',
              label: 'Connected Services Privacy Notice',
            },
          ],
    },
    {
      id: 'search_vehicle_vin',
      regex: '',
      label: 'Vehicle Identification Number',
      title: 'Vehicle Identification Number',
      ariaLabel: 'Vehicle Identification Number',
      messages: {
        info: 'The VIN must be 17 digit long',
        pattern: 'The VIN must be 17 digit long',
        required: 'The VIN field is required',
      },
    },
    {
      id: 'add_vehicle_milage',
      regex: '',
      label: 'Milage',
      title: 'Milage',
      ariaLabel: 'Milage',
      messages: {
        info: 'Milage can be also set as 0',
        pattern: 'Milage not valid',
        required: 'Milage field is required',
      },
    },
  ],
})


export const global_config_be = {
  countriesFlags: {
    at: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-at.svg",
    be: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-be.svg",
    bg: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-bg.svg",
    br: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-br.svg",
    ca: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-ca.svg",
    ch: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-ch.svg",
    cy: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-cy.svg",
    cz: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-cz.svg",
    de: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-de.svg",
    dk: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-dk.svg",
    ee: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-ee.svg",
    es: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-es.svg",
    fi: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-fi.svg",
    fr: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-fr.svg",
    gb: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-gb.svg",
    gr: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-gr.svg",
    hr: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-hr.svg",
    hu: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-hu.svg",
    ie: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-ie.svg",
    is: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-is.svg",
    it: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-it.svg",
    je: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-je.svg",
    li: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-li.svg",
    lt: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-lt.svg",
    lu: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-lu.svg",
    lv: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-lv.svg",
    mt: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-mt.svg",
    mx: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-mx.svg",
    nl: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-nl.svg",
    no: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-no.svg",
    pl: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-pl.svg",
    pt: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-pt.svg",
    ro: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-ro.svg",
    se: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-se.svg",
    si: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-si.svg",
    sk: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-sk.svg",
    us: "aemstagems44-connectivity.jeep.com/content/dam/cws/cross/flags/square/icons-flags-us.svg"
  },
  accessibilityTitles: {
    myGarage: "Go to my garage",
    profile: "View my profile",
    mopar: "",
    notificationCenter: "View my notifications",
    changeAccountPreferences: "Change account preferences",
    changeSecurityPreferences: "Change security preferences",
    changeVehiclePreferences: "Change vehicle $name preferences",
    currentLanguage: "Current language: ",
    socialPage: "Social media page:",
    selectCarCTA: "Select car",
    vehicleHealthPrintIcon: "Print",
    goToAppStore: "Go to App Store",
    goToPlayStore: "Go to Play Store",
    backButton: "Back",
    okBtn: "Ok",
    closeBtn: "Close",
    sendButton: "Send",
    matchPinError: "PINs must match",
    printOrderHistory: "Print order history",
    accept: "Accept",
    decline: "Decline",
    websiteTerms: "Website Terms and Conditions and Privacy Policy",
    connectedTerms: "Connected Services Terms and Conditions",
    curfewInputLabel: "Curfew alert name",
    boundaryInputLabel: "Boundary alert name",
    searchAddress: "Search address",
    cancel: "Cancel label",
    confirm: "Confirm label",
    prefixesList: "Prefixes list",
    seePwd: "Show password",
    showMeSecurityPin: "Show security PIN",
    sendBtn: "Send",
    goToLoginPage: "Go to login page",
    play: "Play video",
    selectContact: "Select your contact type",
    goToVA: "Go to virtual assistant page",
    imgAlternativeText: {
      brandLogo: "Jeep",
      fcaLogo: "FCA logo",
      vehicleImg: "Vehicle image",
      carBrandImage: "Car brand image",
      appStoreLogoAlt: "App Store logo",
      googlePlayStoreLogoAlt: "Google Play Store logo",
      dashboardBanner: "Dashboard banner",
      myUconnectServicesIcon: "My Uconnect Services",
      dashboardSsoIcon: "SSO icon",
      dashboardActiveCar: "Active car",
      dashboardMyImage: "My image",
      backgroundImg: "Background image",
      creditCardImg: "Credit card image",
      sepaImg: "Sepa Image",
      flag: "Flag",
      supportImageFaq: "FAQ image",
      supportImageContactus: "Contact US image",
      purchaseFlowYellowHeader: "Header",
      carImage: "Car image",
      spinnerImage: "Spinner image"
    },
    maps: {
      toggleMapStyle: "Toggle map style",
      showMoreLocations: "Show all locations",
      showLessLocations: "Show less locations"
    },
    offRoad: {
      viewDetailButton: "View off road details"
    },
    form: {
      emailTitle: "Email",
      passwordTitle: "Password"
    },
    editVehicleNickname: "Edit vehicle nickname",
    logo: "Logo",
    image: "Image",
    faqHeroImage: "FAQ hero image",
    expand: "Collapse section",
    collapse: "Expand section",
    goTo: "Go to",
    appleStore: "Apple Store",
    googlePlay: "Google Play",
    video: "Video",
    download: "Download",
    prev: "Previous",
    next: "Next",
    oneNotification: "One notification for",
    goToDashboardPage: "Go to the dashboard page",
    sendForgotPwdBtn: "Send Link for password reset",
    info: "Information",
    isIncluded: "Is included",
    pendingActivation: "Is in pending activation",
    active: "Is active",
    pendingCancellation: "Is in pending cancellation",
    pendingUpgrade: "Is in pending upgrade",
    pendingDowngrade: "Is in pending downgrade",
    inactive: "Is inactive",
    checked: "Checked",
    unchecked: "Unchecked",
    facebook: "Facebook",
    twitter: "Twitter",
    google: "Google",
    linkedin: "LinkedIn",
    yahoo: "Yahoo",
    apple: "Apple",
    socialLogin: "Login with",
    pinDigits: "Digit",
    scrollUpElement: "Scroll to top",
    homePhoneNumber: "Home Phone Number",
    mobileNumber: "Mobile Number",
    theftAlarmLabel: "Suppress Theft Alarm notifications for",
    alertAreSet: "Are Set",
    alertNotSet: "No alerts are set",
    closeBanner: "Close banner",
    closeModal: "Close modal",
    disclaimer: "Disclaimer",
    prevVideo: "View previous video",
    nextVideo: "View next video",
    gotToServices: "Go to services",
    deactivateAccountBtn: "Deactivate account",
    purchaseFlowEditPaymentMethod: "Edit payment method",
    purchaseFlowEditBillingAddress: "Edit billing address",
    followUs: "Follow us",
    dashboard: "Dashboard",
    goToDashboard: "Go to the dashboard page",
    changeLanguage: "Change the language",
    services: "Services",
    goToServicesPage: "Go to the services page",
    support: "Support",
    goToSupportPage: "Go to the support page",
    valetAlertInfoModal: "Open valet alert info modal",
    boundaryAlertInfoModal: "Open boundary alerts info modal",
    curfewAlertInfoModal: "Open curfew alerts info modal",
    speedAlertInfoModal: "Open speed alerts info modal",
    increaseValetAlertRange: "Increase valet alert range",
    decreaseValetAlertRange: "Decrease valet alert range",
    increaseSpeedLimitRange: "Increase speed limit range",
    decreaseSpeedLimitRange: "Decrease speed limit range",
    availableVideoTutorials: "Available video tutorials",
    faqSearchResult: "There are $numberOfHits matching results for your search",
    valetAlertRange: "Valet Alert range",
    viewAllVideos: "View all videos",
    returnToPreviousPage: "Return to previous page",
    phoneNumberPrefix: "Phone prefix",
    viewCarOnDashboard: "View $car on dashboard",
    removedVehicle: "Remove vehicle $car",
    manageCarSubscriptions: "Manage Subscriptions of $car",
    backToProfile: "Profile",
    saveSubscriptionsNot: "Save Subscriptions Messages",
    selectSubTypeOfMsg: "Select $subType to receive $subMsg",
    goToPage: "Go to $page page",
    clearSearch: "Clear search",
    allSubscriptions: "All subscriptions ($subscriptions $item)",
    activeSubscriptions: "Active subscriptions ($subscriptions $item)",
    expiringSubscriptions: "Expiring subscriptions ($subscriptions $item)",
    inactiveSubscriptions: "Inactive subscriptions ($subscriptions $item)",
    closeNotification: "Close notification",
    toggleAlertName: "$alertName",
    toggleAlertEditName: "Edit $alertEditName",
    closeCookiePopUp: "Close cookies pop-up",
    readCookiePolicy: "Read cookie policy",
    lastUpdatedDateVhr: "Last updated $vhrTitle: ",
    immediateActionNeeded: "Immediate action is needed",
    requiresYourAttention: "Requires your attention",
    noSpeedAlertIsSet: "No Speed Alert is set",
    noCurfewAlertIsSet: "No Curfew Alert is set",
    noBoundaryAlertIsSet: "No Boundary Alert is set",
    ofVideoTitle: "Slide $number of $videoTitle",
    prevTitleVideoTab: "View previous $titleVideo video",
    nextTitleVideoTab: "View next $titleVideo video",
    prevTitleVideo: "View previous $title videos",
    nextTitleVideo: "View next $title videos",
    sideBarNavigation: "Side bar navigation",
    paymentMethodEndingWith: "Payment method ending with $maskNumber",
    thisPaymentMethod: "Details about payment method ending with $mask",
    FAQs: "Frequently asked questions",
    vehicles: "Vehicles",
    vehicleModel: "Vehicle - model $carModel",
    goToMyCar: "Go to My $car site",
    readMorePrivacyNotice: "Read more about privacy notice",
    readMoreFACMarketingNotice: "Read more about FCA marketing purpose notice",
    readMorePersonalDataNotice: "Read more about personal data notice",
    readMoreFACPartnersMarketingNotice: "Read more about FCA partners marketing purpose notice",
    readMorePersonalizedMarketingNotice: "Read more about personalised offers",
    main: "Main",
    backToSecurityPage: "Back to security page",
    backToLogin: "Back to login page",
    sendEmailToRecoverPwd: "Send email to recover the password",
    tileInfoImage1: "",
    tileInfoImage2: ""
  },
  currentRegion: 'nafta'
}
